import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { CadastrosService } from '../../services/cadastros.service';
import { UsuarioApi } from '../../model/usuarioApi';

@Component({
  selector: 'app-usuariosapi',
  templateUrl: './usuariosapi.component.html',
  styleUrls: ['./usuariosapi.component.scss']
})
export class UsuariosApiComponent implements OnInit {

  movSub: Subscription;
  usuariosapi: any[];
  fileReader: FileReader;
  fileToRead: File;

  constructor(
      private spinner: NgxSpinnerService,
      private modalService: ModalService,
      private cadastrosService: CadastrosService,
      private toastr: ToastrService,
      private confirmationDialogService: ConfirmationDialogService
  ){

  }

  ngOnInit() {
    this.getusuariosapis();
  }

  async getusuariosapis(){

    this.usuariosapi = [];

    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }

    if (!this.movSub || this.movSub.closed){

      this.spinner.show();

      this.movSub = this.cadastrosService.listar("user/list").subscribe(
        (result: any) =>{

          this.usuariosapi =  result;
          console.log(result);

          this.spinner.hide();

       },error=>{
            console.log(error);
            this.spinner.hide();
       });

    }


  }

  ngOnDestroy(){
    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }
  }

  novousuarioapi(){
    this.modalService.modalDetalhesUsuariosApi.emit(null);
  }

  editar(usuariosapi: UsuarioApi){
    this.modalService.modalDetalhesUsuariosApi.emit(usuariosapi);
  }

  excluir(usuariosapi: UsuarioApi){

    this.confirmationDialogService.confirm('Confirmar?', 'Realmente deseja excluir ?')
      .then((confirmed) =>{

        if(confirmed){
          this.cadastrosService.excluir("user/delete", usuariosapi).subscribe(
            (result) =>{

              this.toastr.success('Usuario Api excluído com sucesso!', 'Sucesso!');
              this.getusuariosapis();
              console.log(result);

            },
            error=> {

              this.toastr.error(error.message, 'Erro!');
              console.log(error);

            }
          );
        }

      })
      .catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });

  }


}
